import { render, staticRenderFns } from "./VCDailyProdutionSummary.vue?vue&type=template&id=06b80f77"
import script from "./VCDailyProdutionSummary.vue?vue&type=script&lang=js"
export * from "./VCDailyProdutionSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports